var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.297 3.57a4.336 4.336 0 1 1 6.133 6.133l-4.078 4.078-.99-.99 4.078-4.078a2.937 2.937 0 0 0-4.153-4.153l-4.078 4.078-.99-.99 4.078-4.078Zm2.055 5.068-7.714 7.714-.99-.99 7.714-7.714.99.99Zm-7.714 2.571L4.56 15.287a2.937 2.937 0 0 0 4.153 4.153l4.078-4.078.99.99-4.078 4.078a4.336 4.336 0 1 1-6.133-6.133l.495.495-.495-.495 4.078-4.078.99.99Z"
})));
export { SvgLink as ReactComponent };
export default __webpack_public_path__ + "201b35802018bfa2804a989c667e108a.svg";